import httpClient from "../../../client/httpClient";

export const fetchShippingFees = async (countryCodes) => {
    try {
        const data = [];
        for (const countryCode of countryCodes) {
            const res = await httpClient.get(
                `/v1/api/base-shipping-fees/get-by-country-code/${countryCode}`
            );
            if (!res.data) {
                throw new Error(`No shipping fees found for country code: ${countryCode}`);
            }
            data.push(res.data);
        }
        return data;
    } catch (error) {
        console.log("Error on fetching all shippingFees", error);
        return Promise.reject(error);
    }
};

export const updateShippingFee = async ({
    countryId,
    minWeight,
    baseShippingFee,
    finalShippingFee
}) => {
    try {
        const res = await httpClient.put(`/v1/api/base-shipping-fees/update/${countryId}`, {
            chargesPerKg: baseShippingFee,
            shippingFeeOverride: finalShippingFee,
            minKg: minWeight,
        });

        return res.data;
    } catch (error) {
        console.log("Error on creating shippingFee", error);
        throw error;
    }
};
